// Реквизиты оператора и версии юридических текстов.
// Реквизиты подставляются во все тексты из src/legal/ (метки вида {{inn}}).
// Версия — дата редакции текста. При правке текста версию менять здесь и в
// core/app/core/legal.py одновременно: сервер принимает согласие только с
// действующей версией.

export const COMPANY = {
  fullName: 'Общество с ограниченной ответственностью «Стратегия кода»',
  shortName: 'ООО «Стратегия кода»',
  inn: '9734029120',
  kpp: '773401001',
  ogrn: '1267700316751',
  address: '123060, г. Москва, ул. Маршала Рыбалко, д.2, к.6, помещ. 28/11',
  domain: 'sledograf.ru',
  contactEmail: 'support@sledograf.ru',
  privacyEmail: 'pd@sledograf.ru',
  effectiveDate: '12 октября 2026 года',
  // политика и согласие на данные аккаунта: состав данных обращений «Сообщить об ошибке»
  dataEditionDate: '18 октября 2026 года'
}

// Ключи совпадают с видами согласий на сервере
export const LEGAL_VERSIONS = {
  terms: '2026-10-12',
  account_data: '2026-10-18',
  news: '2026-10-12',
  telegram: '2026-10-12'
}

export const LEGAL_LINKS = {
  requisites: '/requisites',
  terms: '/terms',
  privacy: '/privacy',
  consentAccount: '/consent/account',
  consentTelegram: '/consent/telegram',
  consentNews: '/consent/news'
}

// Адреса сайта в текстах ({{domain}}, {{domain}}/privacy) становятся ссылками на страницы
function linkSiteAddresses(text) {
  return text.replace(/\{\{domain\}\}(\/\w+)?/g, (match, path) => `[${match}](${path || '/'})`)
}

// Подставляет реквизиты в текст документа
export function fillLegalText(text) {
  return linkSiteAddresses(text).replace(/\{\{(\w+)\}\}/g, (match, key) => (key in COMPANY ? COMPANY[key] : match))
}
